import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import DOMPurify from "dompurify";
import Loader from "../../../components/Loader/Loader";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";
import "../../../components/common/css/campaignview.scss";

const New = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("accessToken");
  const d = new Date(data?.updatedAt);
  const { newsId } = useParams();

  const getDataById = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API}admin/news/${newsId}`,
        { headers: { "x-access-token": token } }
      );

      setData(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: error?.response?.data?.message,
        timerProgressBar: true,
        icon: "error",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
    }
  };

  useEffect(() => {
    getDataById();
  }, [newsId]);

  return (
    <PageShell>
      <PageHead title="News information" />
      <div className="single">
      <Loader isLoading={loading} />
      <div className="singleContainer">
        <div className="top">
          <div className="left">
            <div className="title-topSection">
              <h1 className="title">News Information</h1>
            </div>
            <div className="item">
              <div className="details profile-info">
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">News Title:</span>
                  <span className="itemValue">{data?.title}</span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">News Category:</span>
                  <span className="itemValue">
                    {data?.category?.map((e) => e.category).join(",")}
                  </span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Date:</span>
                  <span className="itemValue">
                    {d?.toLocaleDateString()}
                  </span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Status:</span>
                  <span className="itemValue">
                    {data?.status == 1 ? "Published" : "Draft"}
                  </span>
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">
                    Description:
                  </span>
                  <span
                    className="itemValue"
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.description || '') }}
                  />
                </div>
                <div className="detailItem" style={{ flexBasis: "62%" }}>
                  <span className="itemKey">Banner Image:</span>
                  <span className="itemValue">
                    {data?.bannerURL ? (
                      <img
                        src={data?.bannerURL}
                        alt="Banner"
                        style={{ maxWidth: "50%", height: "50%" }}
                      />
                    ) : (
                      "No banner image available"
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </PageShell>
  );
};

export default New;
